import * as yup from 'yup';

export const ChapterValidation = yup.object({
  bookId: yup.string('Select Book').required('Book is required'),
  chapterName: yup.string('Enter Chapter Name').required('Chapter Name is required'),
  chapterNo: yup
    .string('Enter Chapter No')
    .required('Chapter No is required'),
  url: yup
    .string('Enter URL')
    .url('Please enter a valid URL')
    .nullable()
    .notRequired(),
});

